export default __webpack_public_path__ + "static/media/Gidole-Regular.8ce9f1ae.ttf";